import { render, staticRenderFns } from "./FixCaseButton.vue?vue&type=template&id=25209692"
import script from "./FixCaseButton.vue?vue&type=script&lang=js"
export * from "./FixCaseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports